export default __webpack_public_path__ + "static/media/march2023-2.7083f830.jpg";